import { darkPalette, primaryColor } from "../palette";
export const MuiPickersCalendarHeader = {
  MuiPickersCalendarHeader: {
    iconButton: {
      backgroundColor: primaryColor,
    },
    dayLabel: {
      color: darkPalette.text.secondary,
    },
  },
};
